import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Atoms, atoms, Box, Stack} from '@dropbox/dig-foundations';
import {ReactNode} from 'react';

import {ButtonLink, LinkProps} from './Link';
import {Title} from './Title';

export const EmptyState = ({
  title,
  body,
  ctaLink,
  cta,
  image,
  hideBorder,
  paddingY = '68',
  marginBottom = '44',
}: {
  title: ReactNode;
  body: ReactNode;
  ctaLink?: {to: string; text: ReactNode; state?: LinkProps['state']};
  cta?: {text: ReactNode; onClick: () => void; loading?: boolean};
  image: ReactNode;
  hideBorder?: boolean;
  paddingY?: Atoms['paddingY'];
  marginBottom?: Atoms['marginBottom'];
}) => {
  return (
    <Box
      width="100%"
      paddingY={paddingY}
      display="flex"
      justifyContent="center"
      borderRadius="Medium"
      borderStyle={hideBorder ? undefined : 'Solid'}
      borderColor="Border Subtle"
      textAlign="center"
      placeItems="center"
      marginTop="12"
      marginBottom={marginBottom}
    >
      <Stack gap="8" style={{maxWidth: 460}}>
        <>
          {image}
          <Title size={16} className="ignore">
            {title}
          </Title>
          <Text color="subtle" className={atoms({display: 'block'})}>
            {body}
          </Text>
          {ctaLink && (
            <Box>
              <ButtonLink
                variant="opacity"
                to={ctaLink.to}
                state={ctaLink.state}
                className={atoms({marginTop: '8'})}
              >
                {ctaLink.text}
              </ButtonLink>
            </Box>
          )}
          {cta && (
            <Box>
              <Button
                onClick={cta.onClick}
                variant="opacity"
                isLoading={cta.loading}
                className={atoms({marginTop: '8'})}
              >
                {cta.text}
              </Button>
            </Box>
          )}
        </>
      </Stack>
    </Box>
  );
};
